import {Quill} from 'react-quill';

const Embed = Quill.import('blots/embed');

export type Placeholder = {
    id: string;
    label: string;
};

export class PlaceholderBlotCustomPlaceholder extends Embed {
    static blotName = 'placeholder-custom-placeholder';
    static tagName = 'span';
    static className = 'ql-placeholder-blot-custom-placeholder';

    placeholderValue: Placeholder | null | undefined;

    constructor(domNode: Node, value?: Placeholder) {
        super(domNode, value);
        this.placeholderValue = value;
    }

    static create(value: Placeholder) {
        const node: HTMLElement = super.create(value);
        node.setAttribute('data-id', value.id);
        node.setAttribute('data-label', value.label);
        node.setAttribute('spellcheck', 'false');

        const label = value.label;
        node.innerHTML = label;

        return node;
    }

    value() {
        return '';
    }

    static value(domNode: HTMLElement) {
        return domNode.dataset;
    }

    length(): number {
        return 1;
    }
}
